"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function Brand(_a) {
    var brand = _a.brand, value = _a.value, onChange = _a.onChange, onSubmit = _a.onSubmit, onDelete = _a.onDelete, submitting = _a.submitting;
    var _b = react_1.useState(value), create = _b[0], setCreate = _b[1];
    return react_1.default.createElement("div", { className: 'storybook-channels-brand' },
        react_1.default.createElement("div", { className: 'md:col-span-5' },
            react_1.default.createElement(storybook_1.Channels.BrandingImage, { image: value, brand: brand, type: brand.type, onChange: onChange })),
        react_1.default.createElement("div", { className: 'sm:col-span-7' },
            react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h2' }, brand.label),
            react_1.default.createElement(storybook_1.Texts.Primary, { className: 'mb-4' }, brand.description),
            brand.extensions && (react_1.default.createElement("div", null,
                react_1.default.createElement("span", { className: 'font-semibold' }, "Toegestane bestandsformaat:"),
                " ",
                brand.extensions.join(', '))),
            brand.recommendedSize && (react_1.default.createElement("div", null,
                react_1.default.createElement("span", { className: 'font-semibold' }, "Aanbevolen afmeting:"),
                " ",
                brand.recommendedSize,
                " pixels")),
            react_1.default.createElement("div", { className: 'flex justify-start gap-4 mt-4' },
                onSubmit &&
                    react_1.default.createElement(storybook_1.Buttons.Button, { type: 'primary', onClick: function () { return onSubmit(brand.name).then(function () { return setCreate(true); }); } }, create ? 'Wijzig' : 'Opslaan'),
                create && react_1.default.createElement(storybook_1.Buttons.Button, { type: 'primary', onClick: function () {
                        onDelete();
                        setCreate(false);
                    } }, "Verwijderen"),
                submitting && react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader', className: 'storybook-icons-loader-form' }))));
}
exports.default = Brand;
Brand.propTypes = {
    /**
     * The brand
     */
    brand: prop_types_1.default.object,
    /**
     * The thumbnail image
     */
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.object]),
    /**
     * On submit handler
     */
    onSubmit: prop_types_1.default.func,
    /**
     * On change handler
     */
    onChange: prop_types_1.default.func,
    /**
     * Is submitting (show loader)
     */
    submitting: prop_types_1.default.bool,
};
Brand.defaultProps = {
    submitting: false,
};
